import { compose } from 'redux';
import { connect } from 'react-redux';

import { selectors as uploaderSelectors, fileShape } from 'modules/uploader';
import { sortable } from 'modules/sortable';

import ImageMap from '../components/ImageMap';

import { imageMapsUploader } from '../services/config';
import { updateImageMapOrder } from '../services/actions';

export default compose(
    connect(
        state => ({
            initialItems: uploaderSelectors.selectFileList(state, imageMapsUploader),
        }),
        dispatch => ({
            onSortEnd: info => {
                dispatch(updateImageMapOrder(info));
            },
        }),
    ),
    sortable({
        shape: fileShape,
    }),
)(ImageMap);
